import { createContext, useContext } from 'react';
import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';

interface ModuleDetailContextValue {
  moduleId: number | undefined;
  module: SerializedMeterAddon | undefined;
}

export const ModuleDetailContext = createContext<ModuleDetailContextValue | null>(null);

export const useModuleDetailContext = (): ModuleDetailContextValue => {
  const context = useContext(ModuleDetailContext);

  if (!context) {
    throw new Error('useModuleDetailContext must be used within a ModuleDetailProvider');
  }

  return context;
};
